import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  open(event) {
    event.preventDefault();
    if (window.SfCookieConsent?.showPreferences) {
      window.SfCookieConsent.showPreferences();
    }
  }
}
